export default __webpack_public_path__ + "static/img-mesquita-2-0cfec86ac4c357eabc797f1fdec9ece2.png";